import Vue from 'vue'
import VueRouter from 'vue-router'

import blankLayout from '@/layouts/blankLayout.vue'
import Login from '../views/login/login'
import student from '@/views/student/index'
import teacher from '@/views/teacher/index'
import home from '@/views/home/index'
import order from '@/views/order/index'
import questionBank from '@/views/questionBank/index'
import player from '@/views/course/player'
import DefaultLayout from '../layouts/DefaultLayout.vue';

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function (location, onComplete, onAbort) {
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return originalPush.call(this, location, onComplete, onAbort).catch(err => { })
  } else {
    // <router-link>进行路由跳转时，传了一个oncomplate方法
    originalPush.call(this, location, onComplete, onAbort)
  }
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
    //redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/student',
    name: 'student',
    component: student,
    children: [
      {
        path: "resume",
        name: "resume",
        component: () => import('@/views/student/resume/resume'),
      },

      {
        path: "resumeDetail",
        name: "resumeDetail",
        component: () => import('@/views/student/resume/resumeDetail'),
      },
      {
        path: "myResume",
        name: "myResume",
        component: () => import('@/views/student/resume/myResume'),
      },
      {
        path: "resumePreview",
        name: "resumePreview",
        component: () => import('@/views/student/resumePreview/resumePreview'),
      },
    ]
  },
  {
    path: '/teacher',
    name: 'teacher',
    component: teacher,
    children: [
      {
        path: "resume",
        name: "resume",
        component: () => import('@/views/teacher/resume/resume'),
      },

      {
        path: "resumeDetail",
        name: "resumeDetail",
        component: () => import('@/views/teacher/resume/resumeDetail'),
      },
      {
        path: "myResume",
        name: "myResume",
        component: () => import('@/views/teacher/resume/myResume'),
      },
      {
        path: "resumePreview",
        name: "resumePreview",
        component: () => import('@/views/teacher/resumePreview/resumePreview'),
      },
    ]
  },
  {
    path: '/home',
    name: 'home',
    component: home,
  },
  {
    path: '/course',
    name: 'course',
    component: blankLayout,
    // redirect:'/course/list',
    children: [
      {
        path: "list",
        name: "list",
        component: () => import('@/views/course/list/list.vue'),
      },
      {
        path: "detail/:id",
        name: "detail",
        component: () => import('@/views/course/detail/detail.vue'),
      },
      {
        path: "player/:id/:videoid",
        name: "player",
        component: () => import('@/views/course/player/index.vue'),
      },
      {
        path: "myCourses",
        name: "myCourses",
        component: () => import('@/views/course/myCourses/index.vue'),
      }
    ]
  },
  {
    path: '/questionBank',
    name: 'questionBank',
    component: blankLayout,
    children: [
      {
        path: "questionBankList",
        name: "questionBankList",
        component: () => import('@/views/questionBank/index.vue'),
      },
      {
        path: "examList",
        name: "examList",
        component: () => import('@/views/questionBank/exam/examList.vue'),
      },
      {
        path: "examDetails",
        name: "examDetails",
        component: () => import('@/views/questionBank/exam/examDetails.vue'),
      },
      { 
        path: "reportScore/:id",
        name: "reportScore",
        component: () => import('@/views/questionBank/exam/reportScore.vue'),
      },
      {
        path: "analysis",
        name: "analysis",
        component: () => import('@/views/questionBank/exam/analysis.vue'),
      },{
        path: "wrongDetails",
        name: "wrongDetails",
        component: () => import('@/views/questionBank/exam/wrongDetails.vue'),
      },

    ]
  },
  {
    path: '/order',
    name: 'order',
    component: blankLayout,
    children: [
      {
        path: "orderDetails/:id",
        name: "orderDetails",
        component: () => import('@/views/order/orderDetails/orderDetails.vue'),
      },


    ]
  },
  // {
  //   path: '/',
  //   component: DefaultLayout,
  //   children: [
  //     {
  //       path:'/home',
  //       name:'home',
  //       component: home,
  //     }
  //   ]
  // }


]




const router = new VueRouter({
  routes
})



// router.beforeEach((to, from, next) => {
//   // let whiteRouter  = ['/login',]
//   let whiteRouter = ['/login', '/home', '/course/detail', '/']
//   // 检查是否为 /course/detail/xxx 格式的路由
//   const isCourseDetailRoute = /^\/course\/detail\/\d+$/.test(to.path);

//   let token = localStorage.getItem('token')
//   // 教师页面不判断
//   if (to.path.indexOf('teacher') != -1) {
//     next()
//   }
//   else if (whiteRouter.indexOf(to.path) != -1 || isCourseDetailRoute) {
//     next()
//   }
//   else if (token) {
//     next()
//   } else {
//     next('/login?redirect=' + from.fullPath)
//   }
// })


// 定义一个函数来验证路径是否合法
function isValidRedirect(redirect, whiteList) {
  // 简单示例：验证路径是否以白名单中的路径开头
  return whiteList.some(path => redirect.startsWith(path));
}
router.beforeEach((to, from, next) => {
  // 定义白名单
  const whiteList = ['/login', '/home', '/course/detail', '/','/questionBank/questionBankList'];
  // 检查是否为 /course/detail/xxx 格式的路由
  const isCourseDetailRoute = /^\/course\/detail\/\d+$/.test(to.path);

  // 获取 token
  const token = localStorage.getItem('token');

  // 教师页面不判断
  if (to.path.includes('teacher')) {
      next();
  } 
  // 如果是白名单路由或者课程详情页路由，直接放行
  else if (whiteList.includes(to.path) || isCourseDetailRoute) {
      next();
  } 
  // 如果有 token，放行
  else if (token) {
      next();
  } else {
      const redirect = to.fullPath;
      if (isValidRedirect(redirect, whiteList)) {
          next(`/login?redirect=${redirect}`);
      } else {
          // 如果路径不合法，重定向到主页
          next('/home');
      }
  }
});
export default router
